// extracted by mini-css-extract-plugin
module.exports = {"Centered":"Loader_Centered__3aT8z","Loader":"Loader_Loader__3M_iZ"};